export default "__VITE_ASSET__fc8fe18c__"